<template>
  <div class="home-container">
     <MinProfile></MinProfile>
     <CarouselList ></CarouselList>
     <EventList :isLoading="isLoadingEvent"></EventList>
     <ScreenLoader :isLoading="isLoading" />
     <HomeMenuComponent @componentEvent="handleComponentEvent" />
     <ModalInfo :modalOpen="confirmLogoutModalOpen" @actionTrue="logOut" @actionFalse="confirmLogoutModalOpen = false"> </ModalInfo>
  </div>
</template>

<script>
import MinProfile from '@/components/MinProfile.vue'
import CarouselList from '@/components/CarouselList.vue'
import EventList from '@/components/EventList.vue'

import ScreenLoader from '@/components/loader/ScreenLoader.vue'
import HomeMenuComponent from '@/components/menus/HomeMenuComponent.vue'
import ModalInfo from '@/components/modals/ModalInfo.vue'
import { doLogin, doLogout } from '@/assets/controllers/LoginController'

import { loadMenu } from '@/assets/controllers/MenuController'
import { mapGetters, mapActions } from 'vuex'

import Util from '@/assets/libs/util'

export default {
  name: 'HomeView',
  components: {
    EventList,
    CarouselList,
    MinProfile,
    ScreenLoader,
    HomeMenuComponent,
    ModalInfo
  },
  data () {
    return {
      isLoading: false,
      confirmLogoutModalOpen: false,
      isLoadingEvent: false
    }
  },
  computed: {
    ...mapGetters(['getMenu', 'getUser'])
  },
  methods: {
    ...mapActions(['loadEvents', 'showModalInfo']),
    handleComponentEvent: async function (ev) {
      if (ev.action === 'logOut') {
        // doLogout()
        this.confirmLogoutModalOpen = true
        this.showModalInfo({
          type: 'defaultDialog',
          text: 'Deseja realmente sair?',
          icon: 'fa-solid fa-sign-out-alt'
        })
      } else {
        this.$router.push(ev.action)
      }
    },
    logOut: function () {
      doLogout()
      this.confirmLogoutModalOpen = false
    },
    handleRefresh: async function () {
      if (!this.getMenu?.groups) {
        this.isLoading = true
      }

      const storedUser = Util.getLocalVar('storedUser')
      await doLogin(storedUser.email, '%use@stored@pass%', true, false)

      await this.loadEvents()
      this.isLoadingEvent = false

      const result = await loadMenu()
      if (!result && this.getUser?.consumerType !== 'T') {
        const forceDefaultMenu = true
        const defaultMenuResult = await loadMenu(forceDefaultMenu)

        // caso tenha aparecido o menu padrão, avisar ao usuario que os descontos não serão aplicados
        if (defaultMenuResult) {
          this.showModalInfo({
            type: 'error',
            text: 'Não foi possível carregar os descontos do seu plano. O menu padrão será exibido. Tente novamente ou contate o suporte.',
            icon: 'fa-solid fa-exclamation-triangle',
            open: true
          })
        }
      }

      this.isLoading = false
    }
  },
  created () {
    this.isLoadingEvent = true
    this.handleRefresh()
  }
}
</script>

<style scoped lang="less">
.home-container {
  padding: 80px 20px 0 20px;
  height: calc(var(--real-vh) - 110px);
  overflow-y: auto;
}
</style>
